var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"er-menu__link",attrs:{"to":_vm.route}},[_c('li',{staticClass:"er-menu-item",class:{ 'is-active': _vm.isActive },attrs:{"index":_vm.index,"route":_vm.route}},[_vm._t("default",function(){return [_c('p',{staticClass:"menu-title truncate"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }